import { USER_ACTION_TYPES } from './reducer';

export const actionSetTokenRefreshing = () => ({
	type: USER_ACTION_TYPES.setTokenRefreshing,
	refreshing: true,
});
